import { Logo } from "./Logo";

const COLS: Array<{ heading: string; items: Array<{ label: string; href: string }> }> = [
  {
    heading: "Ürün",
    items: [
      { label: "RADGIS Platform", href: "#urun" },
      { label: "RADGIS CAD", href: "#cad" },
      { label: "Saha Mobil", href: "#cad" },
      { label: "Görev Panosu", href: "#yetenekler" },
    ],
  },
  {
    heading: "Çözümler",
    items: [
      { label: "Altyapı Kurumları", href: "#urun" },
      { label: "Harita & CBS Mühendislik Ofisleri", href: "#urun" },
      { label: "Saha Yüklenicileri", href: "#urun" },
      { label: "Belediye & Telekom", href: "#urun" },
    ],
  },
  {
    heading: "Kurulum",
    items: [
      { label: "Cloud", href: "#kurulum" },
      { label: "On-Premise", href: "#kurulum" },
      { label: "Güvenlik", href: "#kurulum" },
      { label: "SLA", href: "#iletisim" },
    ],
  },
  {
    heading: "Şirket",
    items: [
      { label: "RADGIS", href: "#sirket" },
      { label: "İletişim", href: "#iletisim" },
      { label: "Kariyer", href: "#iletisim" },
      { label: "Basın Kiti", href: "#iletisim" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-card/40">
      <div className="container py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div className="space-y-4">
            <Logo />
            <p className="max-w-sm text-sm text-muted-foreground">
              RADGIS, altyapı ve coğrafi veri yöneten kurumlar için sürdürülebilir CBS/CAD
              platformları geliştirir. RADGIS Platform; saha, ofis ve yönetim katmanlarını tek
              omurgada buluşturur.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.heading}>
              <div className="text-xs font-semibold uppercase tracking-[0.16em] text-foreground/80">
                {col.heading}
              </div>
              <ul className="mt-4 space-y-2 text-sm">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-border/60 pt-6 text-xs text-muted-foreground md:flex-row md:items-center">
          <div>
            © {new Date().getFullYear()} RADGIS Yazılım ve Coğrafi Bilgi Sistemi Teknolojileri AŞ. Tüm hakları
            saklıdır.
          </div>
          <div className="flex items-center gap-4">
            <a href="#iletisim" className="hover:text-foreground">
              KVKK
            </a>
            <a href="#iletisim" className="hover:text-foreground">
              Kullanım Şartları
            </a>
            <a href="#iletisim" className="hover:text-foreground">
              Gizlilik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
